
// Google Analytics Global Site Tag (gtag) utilities
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
    __forceGtag?: boolean;
  }
}

export const gtag = (...args: any[]) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...args);
  } else {
    console.warn('gtag not available');
  }
};

// Initialize gtag if not already loaded
export const initGtag = () => {
  if (typeof window !== 'undefined' && !window.gtag) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() {
      window.dataLayer.push(arguments);
    };
  }
};

// Check if gtag is available and we're on the production domain
export const isGtagAvailable = (): boolean => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return false;
  if (import.meta.env.DEV && window.__forceGtag === true) return true;
  return isProductionDomain();
};

// Only track on the production domain
export const isProductionDomain = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'taxhealth.com.br' || window.location.hostname === 'www.taxhealth.com.br';
};
